import { FC, memo, useEffect, useState } from 'react'
import { Box, Button, Flex, Image, Skeleton, Stack, Text } from '@chakra-ui/react'

import getAssets from 'utils/assets/getAssets'
import { convertBytesNumberToString } from 'utils/transforms/number'
import getFileFromArchive from 'services/calls/file/getFileFromArchive'
import { File } from 'DigitalArchive/types'
import { openFile } from 'utils/files'

type Props = {
  fileId: string
  fileSlug: string
  archiveId: string
}

const CustomFormFileCardToGetFile: FC<Props> = ({ fileId, fileSlug, archiveId }) => {
  const [loadingFile, setLoadingFile] = useState(true)
  const [file, setFile] = useState<File>({})

  async function loadFile() {
    setLoadingFile(true)
    const response = await getFileFromArchive({
      fileId,
      fileSlug,
      archiveId,
    })
    if (response?.header?.success) {
      const fileFromAPI = response?.body?.file
      setFile(fileFromAPI)
    }
    setLoadingFile(false)
  }

  useEffect(() => {
    loadFile()
  }, [])

  return (
    <Stack>
      <Skeleton isLoaded={!loadingFile}>
        <Flex borderWidth="1px" borderColor="borderColor" align="center" rounded="md" gap={2} p={2}>
          <Image
            boxSize="40px"
            backgroundSize="cover"
            src={getAssets('File', file.extension ? file.extension.toLowerCase() : '')}
            alt={file.original_name || file.name}
          />
          <Box>
            <Text wordBreak="break-word">{file.original_name || file.name}</Text>
            <Text textAlign="left" variant="secondary">
              {file.extension ? file.extension.toUpperCase() : ''}, {convertBytesNumberToString(file.size as number)}
            </Text>
          </Box>
        </Flex>
      </Skeleton>

      <Button isLoading={loadingFile} minWidth="100%" onClick={() => openFile(file.url || '')}>
        Abrir documento
      </Button>
    </Stack>
  )
}

export default memo(CustomFormFileCardToGetFile)
